import React from 'react';
import { Localizer } from 'services/Localizer';
import Spinner from 'shared/components/Spinner';
import { DropdownField, TextAreaField, TextBoxField } from 'shared/edit/fields';
import ReCaptchaDisclaimer from 'shared/edit/fields/ReCaptchaDisclaimer';
import InlineAlert from 'shared/edit/InlineAlert';
import RocForm from 'shared/edit/RocForm';
import { useAxiosFormSubmitter } from 'shared/hooks/useBaseAxiosFormSubmitter';

interface SubmitQuestionValues {
	email: string;
	faqCategory?: string;
	question: string;
}

/**
 * Submit Question component
 */
function SubmitQuestion() {
	const submitQuestionSubmitter = useAxiosFormSubmitter<SubmitQuestionValues>(
		{
			url: '/ajax/faq/submit',
		},
		'SubmitQuestion',
	);

	const faqCategories = (window as any).__ROC_FAQ_CATEGORIES__.map((obj) => {
		return {
			text: obj.Name,
			value: obj.Id,
		};
	});

	return !submitQuestionSubmitter.submitted ? (
		<>
			<h1>{Localizer('SubmitQuestionPageTitle')}</h1>
			<RocForm<SubmitQuestionValues>
				onSubmit={submitQuestionSubmitter.handleSubmit}
				initialValues={{
					email: '',
					question: '',
				}}
				render={({ handleSubmit, submitError, submitting }) => {
					return (
						<form onSubmit={handleSubmit} className="roc-contact-form">
							<div className="roc-checkout__section">
								{submitError ? (
									<InlineAlert
										title={Localizer('ErrorMessageGenericTitle')}
										message={submitError}
										error={null}
									/>
								) : null}
								<TextBoxField name="email" label={Localizer('Email')} />
								<DropdownField
									name="faqCategory"
									label={Localizer('FaqCategory')}
									options={faqCategories}
									addSelectOption
									isRequired
								/>
								<TextAreaField name="question" label={Localizer('Question')} />
								<ReCaptchaDisclaimer />
								<button
									disabled={submitting}
									type="submit"
									className="roc-btn"
									data-testid="faq-submit-question"
								>
									{Localizer('Submit')} {submitting ? <Spinner light /> : null}
								</button>
							</div>
						</form>
					);
				}}
			/>
		</>
	) : (
		<>
			<h1>{Localizer('SubmitQuestionConfirmationPageTitle')}</h1>
			<p data-testid="faq-confirmation">{Localizer('QuestionSubmitted')}</p>
		</>
	);
}

export default SubmitQuestion;
